var _defs, _rect, _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNovapointTunnelSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NovapointTunnel_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.58,
    y: 12,
    width: 15,
    height: 18,
    transform: "translate(-0.13 0.1) rotate(-0.36)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.06,17H15L8.23,29H23.82ZM15.9,19h.18l.42,2h-1ZM17,27H15l.5-4h1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24,23V12A8,8,0,0,0,8,12V23L2,29H7.09L14,16.57V16h4v.55L25,29h5ZM16,9a4,4,0,0,0-4,4v6l-2,2V12a6,6,0,0,1,12,0v9l-2-2V13A4,4,0,0,0,16,9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovapointTunnelSvg);
export default __webpack_public_path__ + "static/media/NovapointTunnel_svg.3a4b17906c24c02d2e99d462d27d6d34.svg";
export { ForwardRef as ReactComponent };